<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <wbo-stock-take-single-select-edit-control [(ngModel)]="model.data.stockTakeId"
                                                                   [formControlName]="'stockTakeId'">
                        </wbo-stock-take-single-select-edit-control>
                    </fui-row>
                    <fui-row>
                        <fui-four-columns>
                            <fui-column>
                                <wbo-entity-group-by-report-criteria [showInventoryOption]="true"
                                                                     [showNoGroupOption]="false"
                                                                     [showOutletOption]="true">
                                </wbo-entity-group-by-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-tax-inclusive-report-criteria></wbo-tax-inclusive-report-criteria>
                            </fui-column>
                            <fui-column>
                                <wbo-checkbox-edit-control [(ngModel)]="model.data.stockDiscrepanciesOnly"
                                                           [formControlName]="'stockDiscrepanciesOnly'"></wbo-checkbox-edit-control>
                            </fui-column>
                        </fui-four-columns>
                    </fui-row>
                    <fui-row>
                        <wbo-checkbox-edit-control [(ngModel)]="model.data.showVarianceForPending"
                                                   [formControlName]="'showVarianceForPending'"></wbo-checkbox-edit-control>
                    </fui-row>
                </fui-rows>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
